'use strict';

/**
 * View for rendering the location list
 *
 * @category   View
 * @module     collection.location
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var CompositeView = require('base/Colido.CompositeView');
var MetaStoragesItemView = require('./meta-storages-item');

var template = require('modules/collection/modules/location/templates/partials/meta-storages-list.hbs');

var MetaStoragesListView = CompositeView.extend({
    template: template,

    /**
     * Display as infite view?
     * @type {boolean}
     */
    infiniteView: false,

    childView: MetaStoragesItemView,

    childViewContainer: '#locationsList',

    slider: null,

    /**
     * Options to pass to childView
     * @param [object} model The model
     * @param {int}    index The index of the model
     * @returns {object} The child view options
     */
    childViewOptions: function(model, index) {
        return {
            catalog: this.getOption('catalog'),

            displayImage: this.displayImage,
        };
    },

    onRender: function() {
        // @todo: Export this to a better place
        if (this.getOption('infiniteView')) {
            // due some strange behavior, we have to build the slider with a timeout
            window.setTimeout(function() {
                this.slider = this.$('.sly-frame').sly({
                    horizontal: 1,
                    itemNav: 'basic',
                    speed: 300,
                    mouseDragging: 1,
                    touchDragging: 1,
                    elasticBounds: 1,
                    releaseSwing: 1,
                    //scrollBar: this.$('.sly-scroll'),
                    dynamicHandle: 1,
                    dragHandle: 1,
                });
            }.bind(this), 50);
        }
    },

    onResize: function() {
        if (this.getOption('infiniteView') && this.slider !== null) {
            this.slider.sly('reload');
        }
    },

    /**
     * Destroy plugins and additional listener
     */
    onBeforeDestroy: function() {
        if (this.getOption('infiniteView')) {
            this.slider && this.slider.sly && this.slider.sly('destroy');
        }
    },
});

module.exports = MetaStoragesListView;